import { Component, Input, OnChanges } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { RouterLink } from '@angular/router'
import { DataMap } from '@grapecity/wijmo.grid'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'

import { BaseComponent, EquipmentBrakes, Grid, ListItem, ModalSize } from '../../shared'
import { ActionToolbarButtonsComponent } from '../../shared/reusable-components/action-toolbar-buttons/action-toolbar-buttons.component'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'
import { EquipmentBrakesModalComponent } from './equipment-brakes-modal.component'
import { PartsFluidsEquipmentContext } from './parts-fluids-equipment-context'

@Component({
    selector: 'app-equipment-brakes-list',
    templateUrl: './equipment-brakes-list.component.html',
    standalone: true,
    imports: [
        FormsModule,
        RouterLink,
        ActionToolbarCount,
        ActionToolbarButtonsComponent,
        ActionToolbarSearchComponent,
        WjGridModule,
        WjGridFilterModule,
        AutoSizeDirective,
    ],
})
export class EquipmentBrakesListComponent extends BaseComponent implements OnChanges {
    @Input() canEdit = false
    @Input() equipmentOptions: ListItem<string>[] = []
    @Input() equipmentDataMap!: DataMap
    @Input() allItems: EquipmentBrakes[] = []
    @Input() parent!: PartsFluidsEquipmentContext

    grid: Grid<EquipmentBrakes>

    constructor() {
        super()
        this.grid = new Grid<EquipmentBrakes>(this.services, 'equipment', this)
            .setupModalEditing(
                this.services.data.equipmentBrakes,
                'Brakes',
                EquipmentBrakesModalComponent,
                () => {
                    const item = new EquipmentBrakes()
                    item.id = crypto.randomUUID()
                    return item
                },
                this,
                ModalSize.extraLarge,
            )
            .filterBy(item => [item.equipment, item.axle1Pads, item.axle2Pads, item.axle3Pads, item.axle4Pads])
    }

    ngOnChanges() {
        this.grid.items = this.allItems
    }
}
